function reloadAfterFailure(reload, errorMessage) {
  return Promise.resolve()
    .then(function () {
      return typeof reload === 'function' ? reload() : null;
    })
    .catch(function (reloadError) {
      console.error(errorMessage || 'Unable to reload after an order failure:', reloadError);
      return null;
    });
}

function persistSortOrder(options) {
  options = options || {};
  var message = options.message || 'Unable to save the new order. The latest saved order was reloaded.';
  var context = options.context || 'dashboard data';

  return Promise.resolve()
    .then(function () {
      return options.request();
    })
    .then(function (result) {
      return Promise.resolve()
        .then(function () {
          return typeof options.reload === 'function' ? options.reload() : null;
        })
        .then(function () {
          if (typeof options.onSuccess === 'function') options.onSuccess();
          return result;
        });
    })
    .catch(function (error) {
      console.error('Unable to save reordered ' + context + ':', error);
      if (typeof options.onError === 'function') options.onError(message, error);
      return reloadAfterFailure(options.reload, 'Unable to reload ' + context + ' after an order failure:')
        .then(function () {
          return null;
        });
    });
}

module.exports = {
  persistSortOrder: persistSortOrder
};
